<template>
    <div class="row col-12 pr-0">
        <div class="input-group input-group-sm pl-0 mb-1 col-xl-2 col-lg-3 col-md-4 col-sm-12" v-for="(parameter, index) in parameters" :key="index">
            <div class="input-group-prepend">
                <span class="input-group-text" id="inputGroup-sizing-sm" v-text="parameter.name"></span>
            </div>
            <input type="text" class="form-control" v-model="parameter.default">
        </div>
    </div>
</template>

<script>
    import {mapState} from 'vuex';
    export default {
        computed: {
            ...mapState('reports', {
                parameters: 'parameters',
            })
        },
    }
</script>